<template>
  <div class="ks-vue-component">
    <div class="form-group" :class="{ 'form-group--disabled': disabled }">
      <div class="form__label" v-if="showLabel">
        <template>{{ label }}</template>
      </div>
      <div v-if="showHelpText" class="form__help">{{ helpText }}</div>
      <div
        class="form-group form__button-group__wrapper"
        :class="{ 'form__button-group__wrapper--centered': center }"
      >
        <div v-for="option in options" :key="option.id" class="form__button-group tw:first:[&>label]:rounded-l-md tw:last:[&>label]:rounded-r-md">
          <input
            v-model="valueProxy"
            @click="onChange(option)"
            :id="option.id"
            :value="option.val"
            class="form__button-group__input"
            :disabled="disabled"
            type="radio"
          />
          <label
            class="form__label form__button-group__label"
            :class="{ 'form__button-group__label--checked': valueProxy === option.val,
                        'form__button-group__label--unchecked': !(valueProxy === option.val) }"
            :for="option.id"
          >{{ option.label }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ks-button-group',
    data () {
      return {
        hasFocus: false,
        valueProxy: this.value.val,
      }
    },
    computed: {
      showHelpText () {
        return this.helpText !== ''
      },
      showLabel () {
        return this.label !== ''
      },
    },
    methods: {
      onChange: function (newVal) {
        this.$emit('input', newVal)
      },
    },
    watch: {
      value (newVal, oldVal) {
        this.valueProxy = newVal.val
      },
    },
    props: {
      value: {
        type: Object,
        required: true,
      },
      label: {
        type: String,
        default: '',
      },
      helpText: {
        type: String,
        default: '',
      },
      options: {
        type: Array,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      center: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>
